<template>
  <div class="form_add_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        审核索赔单
      </div>
      <div class="button_list flex-right">
        <el-button
          size="mini"
          type="primary"
          @click="handleHistory"
          style="margin-right: 10px"
          >历史索赔记录</el-button
        >
        <zip-btn
          :canClick="uploading"
          :name="addForm.claimStatementId"
          v-show="fileList && fileList.length > 0"
          :fileList="fileList"
        />
        <el-button size="mini" type="success" @click="handleExamine(1)"
          >预审通过</el-button
        >
        <el-button size="mini" type="danger" @click="handleExamine(2)"
          >驳回</el-button
        >
        <el-button size="mini" type="primary" @click="back">返回列表</el-button>
        <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          size="mini"
          type="primary"
          @click="getNextData('noExamine')"
          >下一条</el-button
        >
      </div>
    </div>
    <div class="status-container">
      <div>索赔单号：{{ addForm.claimStatementId }}</div>
      <div class="status">状态：{{ addForm.auditResultDisplay }}</div>
      <span
        v-if="pageIndex === 'detail'"
        class="btn"
        @click="handleViewRecord('record')"
        >查看记录</span
      >
    </div>

    <div v-if="pageIndex === 'detail'" class="form_info">
      <el-form
        :inline="true"
        :model="addForm"
        :rules="rules"
        ref="form"
        label-width="160px"
      >
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            索赔基本信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="索赔节点" prop="claimNode">
            <el-select v-model="addForm.claimNode" filterable clearable>
              <el-option label="开箱" value="1"> </el-option>
              <el-option label="制程" value="2"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="索赔类型" prop="claimType">
            <el-select v-model="addForm.claimType" filterable clearable>
              <el-option
                v-for="(item, index) in splxList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开箱日期">
            <el-input v-model="addForm.openBoxDate"></el-input>
          </el-form-item>
          <el-form-item label="销售订单号" prop="claimStatementNum">
            <el-input
              v-model="addForm.claimStatementNum"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="VIN" prop="VIN" v-show="addForm.claimNode == 2">
            <el-select
              v-model="addForm.vin"
              @change="changeVin"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder=""
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.vin"
                :label="item.vin"
                :value="item.vin"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item label="国家" prop="country">
            <el-select
              disabled
              filterable
              clearable
              v-model="addForm.countryId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in Object.values(getSession('nationList'))"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户账号" required>
            <el-input v-model="addForm.customerAccount" disabled></el-input>
          </el-form-item>
          <el-form-item label="客户索赔单号">
            <el-input v-model="addForm.customerClaimNumber"></el-input>
          </el-form-item>
        </div>

        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            配件故障信息
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item class="err-nowarp" label="发生日期" prop="happenDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.happenDate"
              placeholder="请选择"
              @change="getPreSetData"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item label="问题类别" prop="problemCategory">
            <el-select v-model="addForm.problemCategory" filterable clearable>
              <el-option label="客户PDI" value="客户PDI"> </el-option>
              <el-option label="终端客户" value="终端客户"> </el-option>
              <el-option label="零部件质量" value="零部件质量"> </el-option>
              <el-option label="零部件差缺" value="零部件差缺"> </el-option>
              <el-option label="零部件运损" value="零部件运损"> </el-option>
              <el-option label="零部件功能性" value="零部件功能性"> </el-option>
              <el-option label="零部件制程" value="零部件制程"> </el-option>
              <el-option label="港口救援" value="港口救援"> </el-option>
              <el-option label="零部件包装" value="零部件包装"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障现象原文"
              prop="symptom"
            >
              <el-input
                type="textarea"
                v-model="addForm.symptom"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.symptom"
                field="symptomCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item label="故障现象">
              <el-input
                type="textarea"
                v-model="addForm.symptomCn"
                style="width: 670px"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.symptomCn"
                field="symptom"
                from="zh-CHS"
                to="en"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障初步原因原文"
              prop="preliminaryCauseOfFailure"
            >
              <el-input
                type="textarea"
                v-model="addForm.preliminaryCauseOfFailure"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.preliminaryCauseOfFailure"
                field="preliminaryCauseOfFailureCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item label="故障初步原因">
              <el-input
                type="textarea"
                v-model="addForm.preliminaryCauseOfFailureCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.preliminaryCauseOfFailureCn"
                field="preliminaryCauseOfFailure"
                from="zh-CHS"
                to="en"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item
              label="故障处理方案原文"
              prop="processingScenarios"
            >
              <el-input
                type="textarea"
                v-model="addForm.processingScenarios"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.processingScenarios"
                field="processingScenariosCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item label="故障处理方案">
              <el-input
                type="textarea"
                v-model="addForm.processingScenariosCn"
                style="width: 670px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="addForm.processingScenariosCn"
                field="processingScenarios"
                from="zh-CHS"
                to="en"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title" v-if="showfaultListError">
          故障件信息
          <div
            v-if="showfaultListError"
            class="is-error"
            style="margin-left: 37px"
          >
            提示：当前故障件暂时无法索赔，请联系所在地区服务经理进行维护
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <div class="table-btn">
            <el-button
              :disabled="tableData.length >= 20"
              type="text"
              class="primary-btn"
              icon="el-icon-plus"
              @click="handleAddFault"
              >新增</el-button
            >
          </div>
          <el-table :data="tableData" border stripe>
            <!-- 序号 -->
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <!-- 外包装箱号 -->
            <el-table-column
              prop="boxNumber"
              label="外包装箱号"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.boxNumber"></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              label="故障件件号"
              align="center"
              min-width="280px"
            >
              <template slot-scope="scope">
                <div>
                  <el-autocomplete
                    :class="
                      scope.row.error
                        ? 'is-error table-auto-input'
                        : 'table-auto-input'
                    "
                    :ref="'autocomplete' + scope.$index"
                    v-model="scope.row.faultPartNumber"
                    placeholder="请输入"
                    :fetch-suggestions="getFaultList"
                    @select="handleSelect($event, scope.$index)"
                    @keyup.enter.native="
                      handleInput('autocomplete' + scope.$index)
                    "
                    @blur="onBlurFault(scope.$index)"
                  ></el-autocomplete>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartNameZh"
              label="故障件名称"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    align="center"
                    v-model="scope.row.faultPartNameZh"
                    @blur="
                      getFaultPartNameCustomer(
                        scope.row.faultPartNameZh,
                        scope.$index
                      )
                    "
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              label="故障件单价"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div style="position: relative;">
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :precision="2"
                    v-model="scope.row.faultPartUnitPrice"
                    class="prepend-padding number-input"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 纸箱号 -->
            <el-table-column
              prop="cartonNumber"
              label="纸箱号"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    align="center"
                    v-model="scope.row.cartonNumber"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              label="数量"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input-number
                    :controls="false"
                    :precision="0"
                    class="number-input"
                    v-model="scope.row.changeQuantity"
                    placeholder="请输入"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              prop="repairPlan"
              label="维修方案"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-select
                    filterable
                    clearable
                    v-model="scope.row.repairPlan"
                    @change="changeScheme(scope)"
                  >
                    <el-option label="维修" :value="0"> </el-option>
                    <el-option label="更换" :value="1"> </el-option>
                    <el-option label="补发" :value="2"> </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <!-- 零部件来源 -->
            <el-table-column
              prop="sourceOfComponents"
              label="零部件来源"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-select
                    filterable
                    clearable
                    v-model="scope.row.sourceOfComponents"
                    @change="getTotalPrice('fault', scope.$index)"
                    :disabled="scope.row.repairPlan != 1"
                    :placeholder="scope.row.repairPlan != 1 ? '' : '请选择'"
                  >
                    <el-option label="收费件" :value="1"> </el-option>
                    <el-option label="海外免费件" :value="2"> </el-option>
                    <el-option label="工厂免费件" :value="3"> </el-option>
                    <el-option label="供应商免费件" :value="4"> </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              label="单件工时"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :max="999"
                    :precision="2"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.workingHours"
                    class="number-input"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              label="运费"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div style="position: relative;">
                  <el-input-number
                    disabled
                    :controls="false"
                    :min="0"
                    :precision="2"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.shippingFee"
                    class="prepend-padding number-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              label="关税"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div style="position: relative;">
                  <el-input-number
                    disabled
                    :controls="false"
                    :min="0"
                    :precision="2"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.tariff"
                    class="prepend-padding number-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              label="其他费用"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div style="position: relative;">
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :precision="2"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.otherExpenses"
                    class="prepend-padding number-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="travelPrice"
              label="差旅费"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div style="position: relative;">
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :precision="2"
                    @change="getTotalPrice('fault')"
                    v-model="scope.row.travelPrice"
                    class="prepend-padding number-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="managementFeeRate"
              label="管理费费率"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>
                  <el-input
                    disabled
                    v-model="scope.row.managementFeeRate"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="laborCost"
              label="工时费用"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ addForm.currency === 0 ? "￥" : "" }}
                  {{ addForm.currency === 1 ? "$" : "" }}
                  {{ scope.row.laborCost }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialCost"
              label="材料费用"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ addForm.currency === 0 ? "￥" : "" }}
                  {{ addForm.currency === 1 ? "$" : "" }}
                  {{ scope.row.materialCost }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="faultPartTotalPrice"
              label="总金额"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>
                  {{ addForm.currency === 0 ? "￥" : "" }}
                  {{ addForm.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column prop="id" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleDeleteFault(scope.$index)"
                >
                  删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            费用信息
          </div>
        </div>
        <div class="form-container">
          <!-- 工时 -->
          <el-form-item label="总工时(h)" prop="manHour">
            <el-input-number
              v-model="addForm.manHour"
              disabled
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              class="number-input"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item label="工时单价" prop="hourlyRate">
            <el-input-number
              disabled
              v-model="addForm.hourlyRate"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item label="工时总费用" prop="totalCostOfWork">
            <el-input-number
              disabled
              v-model="addForm.totalCostOfWork"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item label="材料总费用" prop="materialTotalCost">
            <el-input-number
              disabled
              v-model="addForm.materialTotalCost"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item label="总运费" prop="freight">
            <el-input-number
              disabled
              v-model="addForm.freight"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item label="总关税" prop="tariff">
            <el-input-number
              disabled
              v-model="addForm.tariff"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item label="其他总费用" prop="otherTotalCost">
            <el-input-number
              disabled
              v-model="addForm.otherTotalCost"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 差旅费 -->
          <el-form-item label="差旅费总费用" prop="travelPrice">
            <el-input-number
              disabled
              v-model="addForm.travelPrice"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <br />
          <!-- 其他费用说明 -->
          <el-form-item label="其他费用说明原文">
            <el-input
              v-model="addForm.otherExpenses"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="60px">
            <translate
              :content="addForm.otherExpenses"
              field="otherExpensesCn"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <el-form-item label="其他费用说明">
            <el-input
              v-model="addForm.otherExpensesCn"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="60px">
            <translate
              :content="addForm.otherExpensesCn"
              field="otherInstruction"
              from="zh-CHS"
              to="en"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <!-- 索赔总费用 -->
          <el-form-item label="索赔总费用" prop="claimTotalCost">
            <el-input-number
              disabled
              v-model="addForm.claimTotalCost"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item label="结算币种" prop="currency">
            <el-select disabled v-model="addForm.currency" filterable clearable>
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            附件信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="附件信息" required>
            <div class="flex" v-for="(item, i) in tableData">
              <span style="font-weight: bold">附件{{ i + 1 }}：</span>
              <div class="flex">
                <el-upload
                  class="upload-demo"
                  :ref="'uploadFile' + i"
                  :headers="header"
                  :action="action"
                  :data="extraData"
                  :before-upload="beforeFileUpload"
                  :on-success="
                    (response, file, file_list) => {
                      return handleFileSuccess(response, file, file_list, i);
                    }
                  "
                  :on-remove="
                    (file, file_list) => {
                      return handleRemoveFile(file, file_list, i);
                    }
                  "
                  :on-change="
                    (response, file, file_list) => {
                      return handleChange(response, file, file_list, i);
                    }
                  "
                  multiple
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div>
                  <div
                    v-for="(file, index) in item.fileList"
                    :key="index"
                    class="file-list"
                  >
                    <div>
                      <i
                        class="el-icon-document"
                        style="margin-right: 7px; color: #909399"
                      ></i>
                      <span class="file-name">{{ file.fileName }}</span>
                    </div>
                    <div style="margin-left: 10px">
                      <el-button
                        type="text"
                        size="small"
                        style="padding: 0"
                        @click="downLoad(file)"
                        >下载</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        style="padding: 0"
                        v-if="showViewBtn(file.fileType)"
                        @click="viewFile(file)"
                        >预览</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        style="color: red; padding: 0"
                        @click="handleRemoveFile(file, index, i)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-for="file in fileListIng"
              :key="file.uid"
              class="file-list"
              style="border-bottom: 2px solid #409eff"
            >
              <div>
                <i
                  class="el-icon-document"
                  style="margin-right: 7px; color: #909399"
                ></i>
                <span class="file-name">{{ file.name }}</span>
              </div>
              <div class="file-name" style="margin-left: 10px; font-size: 12px">
                100%
              </div>
            </div>
          </el-form-item>
          <br />
          <el-form-item>
            <div class="tips">
              <p>支持格式：</p>
              <p>1.图片：jpg、png、jpeg、svg</p>
              <span>单张图片不超过10M</span>
              <p>2.视频：mp4 、3gp、mov、m4v</p>
              <span>单个视频不超过500M</span>
              <p>3.表格：xlsx</p>
              <span>单个表格不超过20M</span>
              <p>4.文档：doc、docx、pdf</p>
              <span>单个文档不超过20M</span>
              <p>5.压缩包：rar、zip、7z</p>
              <span>单个压缩包不超过100M</span>
              <p>附件大小：总大小不超过1000M</p>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 车辆基本信息 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img
            class="title-icon"
            src="@/assets/img/title-icon.svg"
            alt="dark"
          />
          历史记录
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="mini"
            @click="handleViewRecord('detail')"
            >返回</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <!-- 驳回弹窗 -->
    <el-dialog :title="examineName" width="550px" :visible.sync="showExamine">
      <el-form
        ref="examineForm"
        :model="examineForm"
        :rules="examineRules"
        label-width="130px"
      >
        <el-form-item
          :label="'请选择' + examineName + '原因'"
          prop="reason"
          style="width: 100%"
        >
          <el-select
            v-model="examineForm.reason"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in reasonList"
              :key="index"
              :label="item.value"
              :value="item.codeText"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="examineForm.reason === '其他'"
          :label="'请选择' + examineName + '原因'"
          prop="remark"
          style="width: 100%"
        >
          <el-input
            type="textarea"
            v-model="examineForm.remark"
            placeholder="请输入"
            maxlength="1000"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="lang-but" type="primary" @click="confirmExamine">确定</el-button>
        <el-button class="lang-but" type="primary" plain @click="showExamine = false">取消</el-button>

      </div>
    </el-dialog>
    <!-- 审核完成弹窗 -->
    <el-dialog
      :visible.sync="showComplete"
      width="420px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      center
    >
      <div style="text-align: center; width: 100%">
        <i
          class="el-icon-warning-outline"
          style="color: #e99d42; margin-right: 13px"
        />{{ completeTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="getNextData"
          >下一条</el-button
        >
        <el-button
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="back"
          >返回列表</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      width="80%"
      title="历史记录"
      :visible.sync="historyDialog"
    >
      <historyList
        ref="historyRef"
        :vin="addForm.vin"
        :claimantNum="addForm.claimStatementNum"
      />
    </el-dialog>
    <view-img-video ref="viewRef" :list="previewList" />
  </div>
</template>

<script>
import { totalSum } from "@/util/totalSum";
import { uploadUrl } from "@/util/url";
import {
  kdpreAuditClaimant,
  getECPData,
  kdPreClimantList,
  getECPDataByVIN,
  kdAuditHistoryList,
  kdgetClimantDetail
} from "@/api/seek";
import { auditHistoryList, getPreset } from "@/api/kdsuopei";
import { deleteFile } from "@/api/customer";
import CryptoJS from "crypto-js";
import { getSession, setStorage, getStorage } from "@/util/localStor";
import Translate from "@/components/translate";
import { getDictItem, getDictValue } from "@/util/dict";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import AuditRecord from "./components/auditRecord.vue";
import zipBtn from "@/components/downloadZip";
import historyList from "./components/historyList.vue";
import { translate } from "@/api/fy";

export default {
  components: { Translate, ViewImgVideo, AuditRecord, zipBtn, historyList },
  data() {
    return {
      submitData: {},
      extraData: {
        fileSource: 19
      },
      splxList: [
        {
          name: "运输损坏",
          id: "1"
        },
        {
          name: "货差",
          id: "2"
        },
        {
          name: "质量问题",
          id: "3"
        },
        {
          name: "状态不符",
          id: "4"
        },
        {
          name: "其他",
          id: "5"
        }
      ], //索赔类型
      partMajorList: [
        {
          name: "车身",
          id: 1
        },
        {
          name: "底盘",
          id: 2
        },
        {
          name: "电器",
          id: 3
        },
        {
          name: "内外饰",
          id: 4
        },
        {
          name: "新能源",
          id: 5
        },
        {
          name: "动力",
          id: 6
        }
      ], //零部件专业
      previewList: [],
      examineName: "", // 审核弹窗名称
      showExamine: false, // 审核弹窗
      showComplete: false, // 审核完成弹窗
      completeTip: "", // 审核完成提示
      completeBtn: false, // 审核完成弹窗按钮状态
      isLoading: false, // 页面加载状态
      faultList: [], // EPC系统故障件数据
      tableData: [], // 其他故障件
      faultError: false, //主因故障件错误
      showfaultListError: false, //其他故障件错误
      happenDateError: false, //发生日期错误
      addForm: {}, // 表单数据
      upLoadFiles: [], // 上传文件
      uploading: false, // 上传状态
      header: {
        satoken: sessionStorage.getItem("token")
      }, // 上传
      action: uploadUrl + "/manage/kdClaimMange/upload", // 上传
      fileList: [], // 上传
      newFileList: [],
      max: 1000, // 上传
      sum: 0, // 上传
      examineForm: {}, // 审核表单数据
      examineRules: {
        reason: [{ required: true, message: " " }],
        remark: [{ required: true, message: " " }]
      }, // 审核表单验证规则
      exchangeRate: "", //汇率
      reasonList: "", // 原因下拉选项
      fileListIng: [],
      pageIndex: "detail",
      recordList: [],
      loading: false,
      options: [],
      list: [],
      historyDialog: false,
      rulesList: {
        claimNode: [{ required: true, message: " " }],
        claimType: [{ required: true, message: " " }],
        claimStatementNum: [{ required: true, message: " " }],
        engineModel: [{ required: true, message: " " }],
        productionDate: [{ required: true, message: " " }],
        happenDate: [
          { required: true, message: " " },
          { validator: this.validateHappenDate }
        ],
        problemCategory: [{ required: true, message: " " }],
        repairPlan: [{ required: true, message: " " }],
        symptom: [{ required: true, message: " " }],
        preliminaryCauseOfFailure: [{ required: true, message: " " }],
        processingScenarios: [{ required: true, message: " " }],
        faultPartNumber: [
          { required: true, message: " " },
          { validator: this.validateFaultPartNumber, trigger: "blur" }
        ],
        faultPartNameZh: [{ required: true, message: " " }],
        faultPartUnitPrice: [{ required: true, message: " " }],
        managementFeeRate: [{ required: true, message: " " }],
        changeQuantity: [{ required: true, message: " " }],
        faultPartTotalPrice: [{ required: true, message: " " }],
        sourceOfComponents: [{ required: true, message: " " }],
        manHour: [{ required: true, message: " " }],
        hourlyRate: [{ required: true, message: " " }],
        totalCostOfWork: [{ required: true, message: " " }],
        materialTotalCost: [{ required: true, message: " " }],
        freight: [{ required: true, message: " " }],
        tariff: [{ required: true, message: " " }],
        claimTotalCost: [{ required: true, message: " " }],
        travelPrice: [{ required: true, message: " " }],
        currency: [{ required: true, message: " " }],
        fileList: [
          { required: true, message: "请上传附件", trigger: "change" }
        ],
        lbjzy: [{ required: true, message: " " }],
        country: [{ required: true, message: " " }]
      }
    };
  },
  watch: {},
  computed: {
    // 表单验证规则
    rules() {
      if (this.addForm.claimNode == 2) {
        return { ...this.rulesList, vin: [{ required: true, message: " " }] };
      } else {
        return { ...this.rulesList };
      }
    }
  },
  created() {},
  async mounted() {
    let isHistory = localStorage.getItem("his");
    if (isHistory == 2) {
      let history = getStorage("history");
      if (JSON.stringify(history) !== "{}") {
        this.historyDialog = history.show;
        this.$nextTick(() => {
          this.$refs.historyRef.showHistoryData();
        });
      }
    }
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      const res = await kdgetClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.addForm = res.data || {};
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    }
    this.fileList = this.addForm.kdClaimFaultyPartsEntityList?.reduce(
      (acc, item) => {
        if (item.fileList && item.fileList.length > 0) {
          acc.push(...item.fileList);
        }
        return acc;
      },
      []
    ); // 初始值为空数组
    this.previewList = this.fileList?.filter(item => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    this.tableData = this.addForm.kdClaimFaultyPartsEntityList || [];
    // 获取汇率
    const exchangeRateDict = await getDictItem("exchangeRate");
    const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
    this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    this.reasonList = await getDictItem("rejectCause");
    const res = await auditHistoryList({
      data: { claimStatementId: this.addForm.claimStatementId }
    });
    this.recordList = res.data;
  },
  methods: {
    // 打开历史详情记录
    handleHistory() {
      this.historyDialog = true;
      this.$nextTick(() => {
        this.$refs.historyRef.initData();
      });
    },
    // 获取详情数据
    async getDetailData() {
      this.fileList = [];
      this.newFileList = [];
      this.previewList = [];
      this.isLoading = true;
      const res = await kdgetClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.addForm = res.data || {};
        this.fileList = this.addForm.kdClaimFaultyPartsEntityList?.reduce(
          (acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }
            return acc;
          },
          []
        ); // 初始值为空数组
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });
        this.tableData = this.addForm.kdClaimFaultyPartsEntityList || [];
        // 获取汇率
        const exchangeRateDict = await getDictItem("exchangeRate");
        const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
        this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
        this.reasonList = await getDictItem("rejectCause");
        const res1 = await auditHistoryList({
          data: { claimStatementId: this.addForm.claimStatementId }
        });
        this.recordList = res1.data;
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    },
    changeScheme(val) {
      if (val.row.repairPlan == 0) {
        this.tableData[val.$index].sourceOfComponents = "";
      }
      this.getTotalPrice("fault", val.$index);
    },
    getSession,
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.addForm, field, value);
    },
    // 根据发生日期获取预设数据
    async getPreSetData() {
      const res = await getPreset({
        data: {
          customerAccountNum: this.addForm.customerAccount,
          happenDate: this.addForm.happenDate
        }
      });
      if (res.data) {
        this.$set(
          this.addForm,
          "managementFeeRate",
          res.data.claimManagementRate
        );
        this.$set(this.addForm, "hourlyRate", res.data.claimUnitPrice);
        this.$set(this.addForm, "currency", res.data.currency);
        this.tableData?.map((item, index) => {
          this.tableData[
            index
          ].managementFeeRate = this.addForm.managementFeeRate;
          if (
            (this.tableData[index].faultPartUnitPrice === 0 ||
              this.tableData[index].faultPartUnitPrice) &&
            (this.tableData[index].changeQuantity === 0 ||
              this.tableData[index].changeQuantity) &&
            (this.tableData[index].managementFeeRate === 0 ||
              this.tableData[index].managementFeeRate)
          ) {
            this.tableData[index].laborCost = parseFloat(
              (
                this.tableData[index].workingHours *
                this.addForm.hourlyRate *
                this.tableData[index].changeQuantity
              ).toFixed(2)
            );

            if (this.tableData[index].repairPlan == 0) {
              // 维修不计算材料费用
              this.tableData[index].materialCost = 0;
            } else {
              // 材料费用 单价*数量*（1+管理费率）
              this.tableData[index].materialCost = parseFloat(
                (
                  this.tableData[index].faultPartUnitPrice *
                  this.tableData[index].changeQuantity *
                  (1 + this.tableData[index].managementFeeRate)
                ).toFixed(2)
              );
            }

            // 总金额
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].laborCost +
              this.tableData[index].materialCost +
              this.tableData[index].shippingFee +
              this.tableData[index].tariff +
              (this.tableData[index].otherExpenses || 0);
          }
        });
        this.getTotalPrice("fault");
        this.happenDateError = false;
      } else {
        this.$set(this.addForm, "managementFeeRate", undefined);
        this.$set(this.addForm, "hourlyRate", undefined);
        this.$set(this.addForm, "currency", undefined);
        this.$set(this.addForm, "materialTotalCost", undefined);
        this.tableData?.map((item, index) => {
          this.tableData[index].managementFeeRate = undefined;
          this.tableData[index].faultPartTotalPrice = undefined;
        });
        this.happenDateError = true;
      }
      this.$refs.form.validateField("happenDate");
    },
    // 校验发生日期
    async validateHappenDate(rule, value, callback) {
      if (this.happenDateError) {
        callback(new Error("提示：请联系所在地区服务经理维护预设数据"));
      } else {
        callback();
      }
    },
    // 判断ECP数据中是否存在该故障件
    async findFault() {
      const faultIndex = this.faultList.findIndex(item => {
        return item.code === this.addForm.faultPartNumber;
      });
      if (faultIndex === -1) {
        this.$set(this.addForm, "faultPartNameZh", "");
        this.$set(this.addForm, "faultPartName", "");
        this.$set(this.addForm, "faultPartUnitPrice", "");
        this.getTotalPrice("fault");
        this.faultError = true;
      } else {
        this.$set(
          this.addForm,
          "faultPartNameZh",
          this.faultList[faultIndex].name
        );
        this.$set(
          this.addForm,
          "faultPartName",
          this.faultList[faultIndex][this.addForm.languageType] ||
            this.faultList[faultIndex]["en"] ||
            this.faultList[faultIndex]["zh"]
        );
        this.$set(
          this.addForm,
          "faultPartUnitPrice",
          this.addForm.currency === 0
            ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(2)
            : this.faultList[faultIndex].price
        );
        this.getTotalPrice("fault");
        this.faultError = false;
      }
    },
    // 校验故障件件号
    validateFaultPartNumber(rule, value, callback) {
      if (this.faultError) {
        callback(
          new Error(
            "提示：当前故障件暂时无法索赔，请联系所在地区服务经理进行维护"
          )
        );
      } else {
        callback();
      }
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = now
        .getSeconds()
        .toString()
        .padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      //拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat)
        .toString()
        .toUpperCase();
      return { appId, timestamp, sign };
    },
    // 根据故障件件号，EPC系统获取故障件
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: this.addForm.customerAccount
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (this.faultList.length === 0) {
        const faultList = await this.getFault(
          this.tableData[index].faultPartNumber
        );
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }
      if (index === 0 || index) {
        if (!this.tableData[index].faultPartNumber) {
          this.tableData[index].error = undefined;
        } else {
          const faultIndex = this.faultList.findIndex(item => {
            return item.code === this.tableData[index].faultPartNumber;
          });
          if (faultIndex === -1) {
            this.tableData[index].faultPartNameZh = "";
            this.tableData[index].faultPartName = "";
            this.tableData[index].faultPartUnitPrice = "";
            this.$set(this.tableData[index], "error", true);
            this.getTotalPrice("fault", index);
          } else {
            this.tableData[index].faultPartNameZh = this.faultList[
              faultIndex
            ].name;
            this.tableData[index].faultPartName =
              this.faultList[faultIndex][this.addForm.languageType] ||
              this.faultList[faultIndex]["en"] ||
              this.faultList[faultIndex]["zh"];
            this.tableData[index].faultPartUnitPrice =
              this.addForm.currency === 0
                ? (
                    this.faultList[faultIndex].price * this.exchangeRate
                  ).toFixed(2)
                : this.faultList[faultIndex].price;
            this.tableData[index].error = undefined;
            this.getTotalPrice("fault", index);
          }
        }
        this.showfaultListError =
          this.tableData.findIndex(item => {
            return item.error === true;
          }) === -1
            ? false
            : true;
      }
    },
    // 选择故障件
    handleSelect(item, index) {
      if (index === 0 || index) {
        this.tableData[index].faultPartNameZh = item.name;
        this.tableData[index].faultPartName =
          item[this.addForm.languageType] || item.en || item.zh;
        this.tableData[index].faultPartUnitPrice =
          this.addForm.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price;
        this.tableData[index].error = undefined;
        this.showfaultListError =
          this.tableData.findIndex(item => {
            return item.error === true;
          }) === -1
            ? false
            : true;
        this.getTotalPrice("fault", index);
      }
    },
    // 获取故障件客户端名称
    async getFaultPartNameCustomer(faultPartNameZh, index) {
      if (!this.addForm.languageType || this.addForm.languageType === "zh") {
        this.tableData[index].faultPartName = faultPartNameZh;
        return;
      }
      try {
        let query = {
          data: {
            text: faultPartNameZh,
            sourceLanguage: "zh-CHS",
            targetLanguage: this.addForm.languageType
          }
        };
        const res = await translate(query);
        if (res.status == 0) {
          this.tableData[index].faultPartName = res.data;
        } else {
          this.$DonMessage.warning("第三方接口反馈出错，请点击翻译按钮重试");
        }
      } catch (error) {}
    },
    // 获取故障件总金额
    getTotalPrice(type, index) {
      if (type === "fault") {
        if (index === 0 || index) {
          // 工时费用（维修方案区分不同算法）
          if (
            (this.tableData[index].workingHours == 0 ||
              this.tableData[index].workingHours) &&
            (this.tableData[index].changeQuantity == 0 ||
              this.tableData[index].changeQuantity) &&
            (this.addForm.hourlyRate == 0 || this.addForm.hourlyRate)
          ) {
            // 工时*工时单价*更换数量 )
            this.tableData[index].laborCost = parseFloat(
              (
                this.tableData[index].workingHours *
                this.addForm.hourlyRate *
                this.tableData[index].changeQuantity
              ).toFixed(2)
            );
          } else {
            this.tableData[index].laborCost = undefined;
          }

          // 材料费用 单价*数量*（1+管理费率）
          if (
            (this.tableData[index].faultPartUnitPrice == 0 ||
              this.tableData[index].faultPartUnitPrice) &&
            (this.tableData[index].changeQuantity == 0 ||
              this.tableData[index].changeQuantity) &&
            (this.tableData[index].managementFeeRate == 0 ||
              this.tableData[index].managementFeeRate)
          ) {
            if (this.tableData[index].repairPlan == 0) {
              // 维修不计算材料费用
              this.tableData[index].materialCost = 0;
            } else {
              this.tableData[index].materialCost = parseFloat(
                (
                  this.tableData[index].faultPartUnitPrice *
                  this.tableData[index].changeQuantity *
                  (1 + this.tableData[index].managementFeeRate)
                ).toFixed(2)
              );
            }
          } else {
            this.tableData[index].materialCost = undefined;
          }
          // 单个故障件总金额
          if (
            (this.tableData[index].laborCost == 0 ||
              this.tableData[index].laborCost) &&
            (this.tableData[index].materialCost == 0 ||
              this.tableData[index].materialCost) &&
            (this.tableData[index].shippingFee == 0 ||
              this.tableData[index].shippingFee) &&
            (this.tableData[index].tariff == 0 || this.tableData[index].tariff)
          ) {
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].laborCost +
              this.tableData[index].materialCost +
              this.tableData[index].shippingFee +
              this.tableData[index].tariff +
              (this.tableData[index].otherExpenses || 0);
          } else {
            this.tableData[index].faultPartTotalPrice = undefined;
          }
        }
        if (this.tableData && this.tableData.length > 0) {
          let materialTotal = 0;
          let workingHoursTotal = 0;
          let laborCostTotal = 0;
          let freightTotal = 0;
          let tariffTotal = 0;
          let otherTotal = 0;
          let travelTotal = 0;
          let workingHourArr = [];
          this.tableData?.map(item => {
            let newWorkingHours = item.workingHours * item.changeQuantity;
            workingHourArr.push(newWorkingHours);

            if (item.sourceOfComponents) {
              if (item.sourceOfComponents == 1) {
                materialTotal += item.materialCost ? item.materialCost : 0; // 计算材料总费用
              }
            } else {
              materialTotal += item.materialCost ? item.materialCost : 0; // 计算材料总费用
            }
            laborCostTotal += item.laborCost ? item.laborCost : 0; // 计算工时总费用
            freightTotal += item.shippingFee ? item.shippingFee : 0; // 计算总运费
            tariffTotal += item.tariff ? item.tariff : 0; // 计算总关税
            otherTotal += item.otherExpenses ? item.otherExpenses : 0; // 计算其他总费用
            travelTotal += item.travelPrice ? item.travelPrice : 0; // 计算差旅总费用
          });
          workingHoursTotal = workingHourArr.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ); // 计算总工时
          this.$set(this.addForm, "materialTotalCost", materialTotal);
          this.$set(this.addForm, "manHour", workingHoursTotal);
          this.$set(this.addForm, "totalCostOfWork", laborCostTotal);
          this.$set(this.addForm, "freight", freightTotal);
          this.$set(this.addForm, "tariff", tariffTotal);
          this.$set(this.addForm, "otherTotalCost", otherTotal);
          this.$set(this.addForm, "travelPrice", travelTotal);
        } else {
          this.$set(this.addForm, "materialTotalCost", undefined);
          this.$set(this.addForm, "manHour", undefined);
          this.$set(this.addForm, "totalCostOfWork", undefined);
          this.$set(this.addForm, "freight", undefined);
          this.$set(this.addForm, "tariff", undefined);
          this.$set(this.addForm, "otherTotalCost", undefined);
        }
        if (
          (this.addForm.totalCostOfWork ||
            this.addForm.totalCostOfWork === 0) &&
          (this.addForm.materialTotalCost ||
            this.addForm.materialTotalCost === 0) &&
          (this.addForm.otherTotalCost || this.addForm.otherTotalCost === 0) &&
          (this.addForm.freight || this.addForm.freight === 0) &&
          (this.addForm.tariff || this.addForm.tariff === 0)
        ) {
          this.$set(
            this.addForm,
            "claimTotalCost",
            Number(this.addForm.totalCostOfWork) +
              Number(this.addForm.materialTotalCost) +
              Number(this.addForm.otherTotalCost) +
              Number(this.addForm.freight) +
              Number(this.addForm.tariff)
          );
        } else {
          this.$set(this.addForm, "claimTotalCost", undefined);
        }
      }
    },
    // 提交时计算总工时等值
    getFinalPrice(arr) {
      if (arr && arr.length > 0) {
        let materialTotal = 0;
        let workingHoursTotal = 0;
        let laborCostTotal = 0;
        let freightTotal = 0;
        let tariffTotal = 0;
        let otherTotal = 0;
        let travelTotal = 0;
        let workingHourArr = [];
        arr?.map(item => {
          let newWorkingHours = item.workingHours * item.changeQuantity;
          workingHourArr.push(newWorkingHours);

          materialTotal += item.materialCost ? item.materialCost : 0; // 计算材料总费用
          laborCostTotal += item.laborCost ? item.laborCost : 0; // 计算工时总费用
          freightTotal += item.shippingFee ? item.shippingFee : 0; // 计算总运费
          tariffTotal += item.tariff ? item.tariff : 0; // 计算总关税
          otherTotal += item.otherExpenses ? item.otherExpenses : 0; // 计算其他总费用
          travelTotal += item.travelPrice ? item.travelPrice : 0; // 计算差旅总费用
        });
        workingHoursTotal = workingHourArr.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        ); // 计算总工时
        this.$set(this.submitData, "materialTotalCost", materialTotal);
        this.$set(this.submitData, "manHour", workingHoursTotal);
        this.$set(this.submitData, "totalCostOfWork", laborCostTotal);
        this.$set(this.submitData, "freight", freightTotal);
        this.$set(this.submitData, "tariff", tariffTotal);
        this.$set(this.submitData, "otherTotalCost", otherTotal);
        this.$set(this.submitData, "travelPrice", travelTotal);
      } else {
        this.$set(this.submitData, "materialTotalCost", undefined);
        this.$set(this.submitData, "manHour", undefined);
        this.$set(this.submitData, "totalCostOfWork", undefined);
        this.$set(this.submitData, "freight", undefined);
        this.$set(this.submitData, "tariff", undefined);
        this.$set(this.submitData, "otherTotalCost", undefined);
      }
      if (
        (this.submitData.totalCostOfWork ||
          this.submitData.totalCostOfWork === 0) &&
        (this.submitData.materialTotalCost ||
          this.submitData.materialTotalCost === 0) &&
        (this.submitData.otherTotalCost ||
          this.submitData.otherTotalCost === 0) &&
        (this.submitData.freight || this.submitData.freight === 0) &&
        (this.submitData.tariff || this.submitData.tariff === 0)
      ) {
        this.$set(
          this.submitData,
          "claimTotalCost",
          Number(this.submitData.totalCostOfWork) +
            Number(this.submitData.materialTotalCost) +
            Number(this.submitData.otherTotalCost) +
            Number(this.submitData.freight) +
            Number(this.submitData.tariff)
        );
      } else {
        this.$set(this.submitData, "claimTotalCost", undefined);
      }
    },
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const { appId, timestamp, sign } = this.getECPParams();
        const params = {
          appId,
          timestamp,
          sign,
          vin: query,
          account: this.addForm.customerAccount
        };
        const res = await getECPDataByVIN(params);
        if (res.data) {
          this.loading = false;
          this.options = res.data;
          this.options?.map((item, i) => {
            if (item.vin == query) {
              this.$set(this.addForm, "claimStatementNum", item.preOrder);
            }
          });
        } else {
          this.loading = false;
          this.options = [];
          this.addForm.vin = query;
          this.$set(this.addForm, "claimStatementNum", "");
        }
      } else {
        this.options = [];
        this.$set(this.addForm, "claimStatementNum", "");
      }
    },
    changeVin(val) {
      this.options?.map((item, i) => {
        if (item.vin == val) {
          this.$set(this.addForm, "claimStatementNum", item.preOrder);
        }
      });
    },
    // 新增其他故障件
    handleAddFault() {
      this.tableData.push({
        faultPartNumber: "", // 故障件件号
        changeQuantity: undefined, // 更换数量
        sourceOfComponents: "", // 零部件来源
        faultPartName: "", // 故障件名称
        faultPartNameZh: "", // 故障件名称中文
        faultPartUnitPrice: "", // 故障件单价
        managementFeeRate: this.tableData[0].managementFeeRate, // 管理费费率
        faultPartTotalPrice: undefined, // 故障件总金额
        boxNumber: "", // 外包装箱号
        cartonNumber: "", //纸箱号
        repairPlan: undefined, //维修方案
        otherExpenses: "", //其他费用
        laborCost: "", //工时费用
        materialCost: "", //材料费用
        workingHours: "", //工时
        shippingFee: "", //运费
        tariff: "", //关税
        travelPrice: "", //差旅费
        fileList: []
      });
    },
    // 删除其他故障件
    handleDeleteFault(index) {
      this.tableData.splice(index, 1);
      this.getTotalPrice("fault");
    },
    // 删除上传文件
    handleRemoveFile(file, file_list, index) {
      this.uploading = false;
      let uid = file.uploadFileId;
      this.tableData[index].fileList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.tableData[index].fileList.splice(i, 1);
        }
      });
      this.fileList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.fileList.splice(i, 1);
        }
      });
      this.previewList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.previewList.splice(i, 1);
        }
      });
    },
    // 删除上传文件
    async deleteUploadFile(data) {
      let query = {
        data: {
          uploadFileId: data.uploadFileId,
          filePath: data.filePath
        }
      };
      const res = await deleteFile(query);
    },
    //上传
    handleChange(file, fileList) {
      this.upLoadFiles = fileList;
    },

    // 上传之前
    beforeFileUpload(file) {
      this.fileListIng.push({
        uid: file.uid,
        name: file.name
      });
      this.uploading = true;
      let total = 0;
      total = this.sum + file.size / 1024 / 1024;
      if (total >= this.max) {
        this.$DonMessage.warning("您上传的附件已超过最高限制1000M");
        this.fileListIng.splice(
          this.fileListIng.findIndex(item => {
            return item.uid === file.uid;
          }),
          1
        );
        this.uploading = false;
        return false;
      }
      const imgLt = 10;
      const videoLt = 500;
      const xlsLt = 20;
      const docLt = 20;
      const zipLt = 100;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSvg = file.type === "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.uploading = false;
          this.$DonMessage.warning("上传图片大小不能超过 10MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isImg && isLt;
      }

      // 视频
      const isMP4 = file.type === "video/mp4";
      const is3GP = file.type === "video/3gpp";
      const isMOV = file.type === "video/quicktime";
      const isM4V = file.type === "";
      let isVideo = false;
      if (isMP4 || is3GP || isMOV) {
        isVideo = true;
      }
      if (isVideo) {
        limit = videoLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传视频大小不能超过 500MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }
        return isVideo && isLt;
      }

      // 表格
      const isXLS =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isXLS) {
        limit = xlsLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传表格大小不能超过 20MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }
        return isXLS && isLt;
      }

      // 文档
      const isDOC = file.type === "application/msword";
      const isDOCX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPDF = file.type === "application/pdf";
      let isFile = false;
      if (isDOC || isDOCX || isPDF) {
        isFile = true;
      }
      if (isFile) {
        limit = docLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传文档大小不能超过 20MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }
        return isFile && isLt;
      }

      // 压缩包
      const isZIP =
        file.type === "application/zip" ||
        file.name.endsWith(".zip") ||
        file.name.endsWith(".rar") ||
        file.name.endsWith(".7z");
      if (isZIP) {
        limit = zipLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传压缩包大小不能超过 100MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }
        return isZIP && isLt;
      }
    },
    // 上传成功
    handleFileSuccess(res, file, file_list, i) {
      this.fileListIng.splice(
        this.fileListIng.findIndex(item => {
          return item.uid === file.uid;
        }),
        1
      );
      this.uploading = true;
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: encodeURI(data.filePath),
          fileSource: data.fileSource,
          name: data.fileName,
          url: encodeURI(data.filePath)
        };
        this.tableData[i].fileList.push(obj);
        this.fileList.push(obj);
        if ("image,video".indexOf(obj.fileType.slice(0, 5)) !== -1) {
          this.previewList.push(obj);
        }
        const total = totalSum(this.fileList, "fileSize");
        this.sum = total / 1024;
        this.uploading = false;
        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
      } else {
        this.$DonMessage.error(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile[i].uploadFiles.findIndex(
          item => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
      }
    },
    // 审核
    async audit(status, remark) {
      this.submitData = {};
      this.submitData = JSON.parse(JSON.stringify(this.addForm));
      var canSubmit = true;
      this.submitData.kdClaimFaultyPartsEntityList = [];
      this.tableData?.map(item => {
        if (item.faultPartNumber) {
          this.submitData.kdClaimFaultyPartsEntityList.push(item);
        }
        if (
          item.faultPartNumber &&
          item.fileList &&
          item.fileList.length == 0
        ) {
          this.$DonMessage.warning("请给故障件上传相关附件后再提交");
          canSubmit = false;
        }
      });
      if (this.tableData && this.submitData.kdClaimFaultyPartsEntityList) {
        if (
          this.tableData.length !=
          this.submitData.kdClaimFaultyPartsEntityList.length
        ) {
          this.getFinalPrice(this.submitData.kdClaimFaultyPartsEntityList);
        }
      }
      this.submitData.status = status;
      this.submitData.remark = remark;

      if (canSubmit) {
        if (status == 2) {
          this.isLoading = true;
          try {
            var res = await kdpreAuditClaimant({ data: this.submitData });
            if (res.status == 0) {
              this.isLoading = false;
              this.completeTip = `索赔订单 ${this.submitData.claimStatementId} 已${this.examineName}`;
              this.showComplete = true;
            } else {
              this.isLoading = false;
              this.$DonMessage.error(res.message);
            }
          } catch (error) {
            this.isLoading = false;
          }
        } else {
          this.$refs.form.validate(async valid => {
            if (valid) {
              this.isLoading = true;
              try {
                var res = await kdpreAuditClaimant({ data: this.submitData });
                if (res.status == 0) {
                  this.isLoading = false;
                  this.completeTip = `索赔订单 ${this.submitData.claimStatementId} 已${this.examineName}`;
                  this.showComplete = true;
                } else {
                  this.isLoading = false;
                  this.$DonMessage.warning(res.message);
                }
              } catch (error) {
                this.isLoading = false;
              }
            } else {
              this.$DonMessage.warning("请将信息填写完整");
            }
          });
        }
      }
    },

    // 点击审核
    async handleExamine(type) {
      if (type == 1) {
        this.examineName = "预审通过";
        this.pageIndex = "detail";
        if (this.pageIndex == "detail") {
          this.$nextTick(() => {
            this.audit(3);
          });
        }
      } else {
        this.examineName = "驳回";
        this.showExamine = true;
        this.examineForm = {};
        this.$nextTick(() => {
          this.$refs.examineForm.clearValidate();
        });
      }
    },
    // 下一条
    async getNextData(type) {
      this.completeBtn = true;
      let query = JSON.parse(this.$route.query?.searchObj);
      if (type === "noExamine") {
        this.isLoading = true;
        query.page.pageNum = query.page.pageNum + 1;
      }
      const res = await kdPreClimantList(query);
      if (res.status == 0) {
        this.completeBtn = false;
        this.isLoading = false;
        this.showComplete = false;
        if (res.data.records[0]) {
          setStorage("claimantData", res.data.records[0]);
          this.$router.replace({
            path: "/kd-claimant/edit",
            query: {
              claimantId: res.data.records[0].claimStatementId,
              searchObj: JSON.stringify({
                ...query
              }),
              enableNext: this.$route.query?.enableNext
            }
          });
          this.getDetailData();
        } else {
          this.$DonMessage.warning("筛选索赔单已审核完！")
        }
      } else {
        this.completeBtn = false;
        this.isLoading = false;
        this.$DonMessage.error(res.message);
      }
    },
    // 确认驳回
    confirmExamine() {
      this.$refs.examineForm.validate(async valid => {
        const submitData =
          this.examineForm.reason === "其他"
            ? this.examineForm.remark
            : this.examineForm.reason;
        this.showExamine = false;
        this.audit(2, submitData);
      });
    },
    // 下载
    downLoad({ filePath }) {
      window.open(filePath);
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.form_add_page {
  padding-bottom: 20px;
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
    padding-left: 150px;
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: center;
    }
  }


  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
  .file-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 26px;
    padding-left: 4px;
    margin-top: 5px;
    .file-name {
      color: #606266;
    }
  }
  ::v-deep .el-upload-list {
    display: none;
  }
}
</style>
